module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.price),
      expression: "item.price"
    }],
    ref: 'price' + _vm.id,
    staticClass: "input-option h-38",
    attrs: {
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.item.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "price", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06133799"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/PriceInput.vue
// module id = 2301
// module chunks = 1